/** Ensure Raipur, Bhilai, Durg always appear in city search dropdowns. */
const DEFAULT_CG_CITIES = [
  { id: "cg-raipur", name: "Raipur" },
  { id: "cg-bhilai", name: "Bhilai" },
  { id: "cg-durg", name: "Durg" },
  { id: "cg-bilaspur", name: "Bilaspur" },
  { id: "cg-korba", name: "Korba" },
];

export function mergeCityOptions(apiCities = []) {
  const list = Array.isArray(apiCities) ? [...apiCities] : [];
  const names = new Set(
    list.map((c) => String(c.name || "").trim().toLowerCase()).filter(Boolean),
  );

  for (const city of DEFAULT_CG_CITIES) {
    const key = city.name.toLowerCase();
    if (!names.has(key)) {
      list.push({ ...city });
      names.add(key);
    }
  }

  return list.sort((a, b) =>
    String(a.name || "").localeCompare(String(b.name || ""), "en", {
      sensitivity: "base",
    }),
  );
}

export const SIGNUP_WIZARD_STORAGE_KEY = "dw_signup_wizard";

export function saveSignupWizardCredentials(userId, password) {
  try {
    sessionStorage.setItem(
      SIGNUP_WIZARD_STORAGE_KEY,
      JSON.stringify({
        userId: String(userId || ""),
        password: String(password || ""),
        at: Date.now(),
      }),
    );
  } catch {
    /* ignore quota */
  }
}

export function readSignupWizardCredentials() {
  try {
    const raw = sessionStorage.getItem(SIGNUP_WIZARD_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.userId) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearSignupWizardCredentials() {
  try {
    sessionStorage.removeItem(SIGNUP_WIZARD_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
